<template>
  <div class="page-container content-430">
    <div class="item-box-430">
      <div class="org-head">
        <div class="box-title-430">配置服务学校</div>
        <div>
          <Button
            class="back-btn"
            type="primary"
            @click="handleToOpenRec"
          >操作日志</Button>
          <Button
            class="back-btn"
            type="primary"
            @click="back"
          >返回上一步</Button>
        </div>
      </div>
      <div class="info-box">
        <div class="headwrap">基础信息</div>
        <div class="baseWrap">
          <div class="fontItem">学年：{{ yearName }}</div>
          <div class="fontItem">学期：{{ termName }}</div>
        </div>
        <div class="headwrap">配置服务机构</div>
        <div class="main-wrapper item-box-430">
          <div class="headtwrap">
            <div>
              已选 <span style="font-weight: 600">{{ pageOrgInfo.total }}</span>个机构
            </div>
            <Button type="primary" @click="addOrg">添加机构</Button>
          </div>
          <div class="table">
            <Table
              :loading="orgLoading"
              border
              :columns="orgTableColumns"
              :data="orgTableData"
            >
              <template slot="action" slot-scope="{ row }">
                <span
                  class="del-btn-430"
                  @click="deleteSchool(row, 1)"
                >删除</span>
              </template>
            </Table>
          </div>
          <div class="paging">
            <Page
              :total="pageOrgInfo.total"
              show-total
              show-elevator
              :current="pageOrgInfo.pageNum"
              :page-size="pageOrgInfo.pageSize"
              @on-change="handleOrgPageChange"
            ></Page>
          </div>
        </div>
        <div class="headwrap">配置学校</div>
        <div class="main-wrapper item-box-430">
          <div class="headtwrap">
            <div>
              已选
              <span style="font-weight: 600">{{ pageSchoolInfo.total }}</span>个学校
            </div>
            <Button type="primary" @click="addSchool">添加学校</Button>
          </div>
          <div class="table">
            <Table
              :loading="schoolLoading"
              border
              :columns="schoolTableColumns"
              :data="schoolTableData"
            >
              <template slot="action" slot-scope="{ row }">
                <span
                  class="operate-btn-430"
                  @click="editSchoolNum(row)"
                >编辑</span>
                <span
                  class="del-btn-430"
                  @click="deleteSchool(row, 2)"
                >删除</span>
              </template>
            </Table>
          </div>
          <div class="paging">
            <Page
              :total="pageSchoolInfo.total"
              show-total
              show-elevator
              :current="pageSchoolInfo.pageNum"
              :page-size="pageSchoolInfo.pageSize"
              @on-change="handleSchoolPageChange"
            ></Page>
          </div>
        </div>
      </div>
    </div>
    <!-- 编辑学校人数 -->
    <Modal v-model="modalEditShow" title="编辑学校信息" width="50">
      <div class="page_modal">
        <div>
          <span class="modaltitle">学校名称：</span> {{ actItem.orgName }}
        </div>
        <div class="dwrap">
          <span class="modaltitle"><span style="color: red">*</span>本学期学生人数：</span>
          <InputNumber
            v-model="studentnumber"
            style="width: 230px"
            :min="0"
            :max="999999"
            :precision="0"
            placeholder="请输入学校人数"
          ></InputNumber>
          <span style="margin: 0 20px">基础平台：{{ showNum }} </span><Button
            type="primary"
            shape="circle"
            @click="handleChangeStudentnumber"
          >一键填写</Button>
        </div>
      </div>
      <div slot="footer">
        <Button type="text" @click="handleCancel()">取消</Button>
        <Button type="primary" @click="handleOK()">确定</Button>
      </div>
    </Modal>
    <!-- 选择机构 -->
    <ChooseOrgModal
      ref="ChooseOrgModal"
      @on-finish="handleonFinish"
    ></ChooseOrgModal>
    <!-- 选择学校 -->
    <ChooseSchoolModal
      ref="ChooseSchoolModal"
      @on-finish="handleSchoolFinish"
    ></ChooseSchoolModal>
    <SmsCodeModal
      ref="smsCodeModalRef"
      :modal-title="`删除确认`"
      :check-type="`sysTermBureauDeleteRelOrg`"
      :modal-loading="modalLoading"
      @sendCode="delTrue"
    >
      <template #header>
        <div v-if="selectIndex === 1">
          <p style="margin-bottom: 8px">
            ①是否确认删除该机构，删除不会解绑机构与教育局的合作关系，但将影响在学期服务管理中的存在。且学期机构检索范围将不含该机构。
          </p>
          <p>
            ②如果机构与教育局解除合作关系，则不影响之前已添加的配置机构服务。
          </p>
        </div>
        <div v-if="selectIndex === 2">
          <p style="margin-bottom: 8px">
            ①是否确认删除该学校单位？删除不会真正删除该学校单位，但将影响在该学校<span
              style="font-weight: bold; color: red"
            >课程、订单、退款</span>等数据维度在该教育局统计。删除后，该学校数据将<span
              style="font-weight: bold; color: red"
            >不计入</span>该教育局的数据统计范围。
          </p>
          <p>②删除后，学期学校范围检索，将不含有该机构。</p>
        </div>
      </template>
    </SmsCodeModal>
    <RecModal ref="recModal" :code-type-map="codeTypeMap"></RecModal>
    <ResultModal
      ref="resultModal"
      :modal-type="1"
      modal-text="删除成功"
    ></ResultModal>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import SmsCodeModal from '@c/Base/SmsCodeModal.vue';
import RecModal from '@c/RecModal';
import ChooseOrgModal from './components/ChooseOrgModal';
import ChooseSchoolModal from './components/ChooseSchoolModal';
import ResultModal from './components/ResultModal';
import educationAdmin from '@/request/educationAdmin/index.js';
import {
  schoolTableColumnsData,
  orgTableColumnsData
} from './assets/data/eduData';
export default {
  components: {
    ChooseOrgModal,
    ChooseSchoolModal,
    SmsCodeModal,
    RecModal,
    ResultModal
  },
  data() {
    return {
      actItem: {},
      yearName: '',
      termName: '',
      // 学校人数
      studentnumber: 0,
      // 学校信息编辑
      modalEditShow: false,
      orgTableData: [],
      schoolTableData: [],
      pageOrgInfo: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      pageSchoolInfo: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      orgTableColumns: orgTableColumnsData,
      schoolTableColumns: schoolTableColumnsData,
      orgLoading: false,
      schoolLoading: false,
      selectIndex: -1,
      selectRelId: '',
      modalLoading: false,
      showNum: 0,
      codeTypeMap: {
        'SYS_TERM_BUREAU_ORG_ITEM_OPERATE@ORG_ADD': '服务机构添加',
        'SYS_TERM_BUREAU_ORG_ITEM_OPERATE@SCHOOL_ADD': '服务学校添加',
        'SYS_TERM_BUREAU_ORG_ITEM_OPERATE@ORG_DELETE': '服务机构删除',
        'SYS_TERM_BUREAU_ORG_ITEM_OPERATE@SCHOOL_DELETE': '服务学校删除',
        'SYS_TERM_BUREAU_ORG_ITEM_OPERATE@SCHOOL_UPDATE': '服务学校编辑'
      }
    };
  },
  computed: { ...mapState(['userInfo']) },
  created() {
    this.bureauTermId = this.$route.query.bureauTermId ? this.$route.query.bureauTermId : '';
    this.yearName = this.$route.query.yearName ? this.$route.query.yearName : '';
    this.termName = this.$route.query.termName ? this.$route.query.termName : '';
    this.initOrgDataList();
    this.initSchoolDataList();
  },
  methods: {
    // 获取班级列表数据
    async getclassListData(searchStr, orgId) {
      // this.searchForm,
      return new Promise(async(resolve, reject) => {
        const params = {
          pageNum: 1,
          pageSize: 1000,
          searchStr
        };
        this.loading = true;
        try {
          const res = await educationAdmin.getEduRelBasicSchoolApi(params);
          this.loading = false;
          if (res.status === 200) {
            console.log(res.message);
            const index = res.message.list.findIndex(item => {
              return item.orgId === orgId;
            });
            const num = index === -1 ? 0 : res.message.list[index].studentCnt;
            resolve(num);
          } else {
            reject(false);
          }
        } catch (err) {
          reject(false);
        }
      });
    },
    handleChangeStudentnumber() {
      this.studentnumber = +this.showNum;
    },
    handleToOpenRec() {
      this.$refs.recModal.handleShow({ objectId: this.bureauTermId, recType: 'SYS_TERM_BUREAU_ORG_ITEM_OPERATE@' });
    },
    // 获取已选的机构列表
    async getSelectedList(orgType) {
      return new Promise(async(resolve, reject) => {
        try {
          const params = {
            bureauTermId: this.bureauTermId, // 学期id
            orgType // 单位类型 1：学校 4：机构
          };
          const res = await educationAdmin.getExistListRelOrgApi(params);
          if (res.status === 200) {
            resolve(res.message);
          } else {
            reject(false);
          }
        } catch (err) {
          reject(false);
        }
      });
    },
    // index 1机构 2学校
    deleteSchool(row, index) {
      this.selectIndex = index;
      this.selectRelId = row.relId;
      this.$refs.smsCodeModalRef.handleOpen();
    },
    async delTrue(code) {
      this.modalLoading = true;
      try {
        const params = {
          relId: this.selectRelId,
          msg: code
        };
        const res = await educationAdmin.sysTermBureauOrgsdeleteRelOrgApi(params);
        if (res.status === 200) {
          this.$refs.smsCodeModalRef.handleClose();
          this.$refs.resultModal.open();
          if (this.selectIndex === 1) {
            this.initOrgDataList();
          } else {
            this.initSchoolDataList();
          }
        } else {
          this.$Message.error(res.message);
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.modalLoading = false;
      }
    },
    async editSchoolNum(row) {
      this.actItem = row;
      this.studentnumber = row.studentCnt;
      this.showNum = await this.getclassListData(row.orgName, row.orgId);
      this.modalEditShow = true;
    },

    initOrgDataList() {
      const params = { ...this.pageOrgInfo, orgType: 4, bureauTermId: this.bureauTermId };
      this.orgLoading = true;
      educationAdmin.sysTermBureauOrgslistOrgApi(params).then((res) => {
        this.orgLoading = false;
        if (res.status === 200) {
          this.orgTableData = res.message.list;
          this.pageOrgInfo.total = Number(res.message.total);
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    initSchoolDataList() {
      const params = { ...this.pageSchoolInfo, orgType: 1, bureauTermId: this.bureauTermId };
      this.schoolLoading = true;
      educationAdmin.sysTermBureauOrgslistOrgApi(params).then((res) => {
        this.schoolLoading = false;
        if (res.status === 200) {
          this.schoolTableData = res.message.list;
          this.pageSchoolInfo.total = Number(res.message.total);
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    handleCancel() {
      this.modalEditShow = false;
    },
    handleOK() {
      const params = {
        relId: this.actItem.relId,
        studentCnt: this.studentnumber
      };
      educationAdmin.sysTermBureauOrgsupdateRelOrgApi(params).then((res) => {
        if (res.status === 200) {
          this.$Message.success('操作成功');
          this.modalEditShow = false;
          this.initSchoolDataList();
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    handleonFinish(result) {
      console.log('result', result);
      if (result.length === 0) {
        this.$Message.error('请选择数据');
        return;
      }
      const orgInfos = result.map((item) => {
        return {
          orgId: item.orgId
        };
      });
      const params = {
        'bureauTermId': this.bureauTermId,
        'orgType': 4,
        orgInfos
      };
      educationAdmin.sysTermBureauOrgsaddRelOrgApi(params).then((res) => {
        if (res.status === 200) {
          this.$Message.success('操作成功');
          this.$refs.ChooseOrgModal.handleClosure();
          this.initOrgDataList();
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    handleSchoolFinish(result) {
      if (result.length === 0) {
        this.$Message.error('请选择数据');
        return;
      }
      const orgInfos = result.map((item) => {
        return {
          orgId: item.orgId,
          studentCnt: item.stunumber
        };
      });
      const params = {
        'bureauTermId': this.bureauTermId,
        'orgType': 1,
        orgInfos
      };
      educationAdmin.sysTermBureauOrgsaddRelOrgApi(params).then((res) => {
        if (res.status === 200) {
          this.$Message.success('操作成功');
          this.$refs.ChooseSchoolModal.handleClosure();
          this.initSchoolDataList();
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    async addOrg() {
      const selectedIdList = await this.getSelectedList(4);
      this.$refs.ChooseOrgModal.handleOpen(
        [],
        selectedIdList
      );
    },
    async addSchool() {
      const selectedIdList = await this.getSelectedList(1);
      this.$refs.ChooseSchoolModal.handleOpen(
        [],
        selectedIdList
      );
    },
    handleOrgPageChange(v) {
      this.pageOrgInfo.pageNum = v;
      console.log(v, '拿到的----');
      this.initOrgDataList();
    },
    handleSchoolPageChange(v) {
      this.pageSchoolInfo.pageNum = v;
      this.initSchoolDataList();
    },

    // 返回上一步
    back() {
      this.$router.go(-1);
    },
    handleSendCode(e) {
      console.log(e);
    }

  }
};
</script>
<style lang="scss" scoped>
.dwrap {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.modaltitle {
  font-weight: bolder;
}

.headtwrap {
  width: 100%;
  padding: 0 20px 20px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  display: flex;
}

.page-container {
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  padding-bottom: 100px !important;

  .info-box {
    padding: 20px;

    .headwrap {
      width: 100%;
      background-color: #f3f3f3;
      box-sizing: border-box;
      padding: 15px 20px;
      color: #333333;
      font-size: 14px;
      font-weight: bold;
      border-radius: 10px;
    }

    .baseWrap {
      display: flex;
      flex-direction: column;
      padding-left: 20px;
      padding-top: 20px;
      margin-bottom: 20px;

      .fontItem {
        font-size: 15px;
        padding: 10px 0;
      }
    }
  }

  .org-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 16px;
    border-bottom: 1px solid #ccc;
    .back-btn + .back-btn {
      margin-left: 16px;
    }
    // .back-btn {
    //   margin-left: auto;
    // }
  }

  .org-title {
    display: flex;
    align-items: center;
    padding-top: 16px;

    .org-status {
      margin-left: 32px;
    }
  }
}
</style>
